import { Outlet } from 'react-router-dom';

export default function Settlements() {
    return (
        <Outlet />
    )
}
